module.exports = __webpack_public_path__ + "img/welms_video.f12bf24a.jpg";